// Language switcher is temporarily hidden while English copy is being revised.
// Re-enable by restoring the full component from git history.
export default function LanguageSwitcher() {
  return null;
}
